import classes from "./index.module.scss";
import imgWebp from "../../../../assets/img/landings/nextres/banner.webp";
import imgPng from "../../../../assets/img/landings/nextres/banner.png";

export default function Banner() {
  return (
    <section className={classes.section}>
      <picture>
        <source srcSet={imgWebp} type="image/webp" />
        <source srcSet={imgPng} type="image/png" />
        <img
          src={imgPng}
          alt="Banner"
          width={1079}
          height={693}
          loading="lazy"
        />
      </picture>
    </section>
  );
}
